import React from 'react';
import { Input } from '../../Input';
import { Select } from '../../Select';
import { DOSAGE_UNITS, DosageUnit } from '../../../types/data';

interface DosageInputsProps {
  dosage: number;
  dosageUnits: DosageUnit;
  onDosageChange: (value: number) => void;
  onUnitsChange: (value: DosageUnit) => void;
  error?: string;
}

export const DosageInputs: React.FC<DosageInputsProps> = ({
  dosage,
  dosageUnits,
  onDosageChange,
  onUnitsChange,
  error,
}) => {
  return (
    <>
      <Input
        label="Dosage"
        tooltip="Enter the desired amount of peptide to administer per dose. For example, 0.5 mg or 100 mcg depending on your protocol."
        value={dosage}
        onChange={onDosageChange}
        error={error}
      />
      <Select
        label="Dosage Units"
        tooltip="Select the measurement units for your dosage, such as milligrams (mg) or micrograms (mcg), based on your peptide protocol."
        value={dosageUnits}
        onChange={onUnitsChange}
        options={DOSAGE_UNITS}
      />
    </>
  );
};
